import { AwsRum, AwsRumConfig } from 'aws-rum-web';

/**
 * CloudWatch RUM client for PublicNoticeFormWebsite.
 *
 * Reuses the same RUM app monitor and Cognito identity pool as RAVUnifiedPortalWebsite
 * since both sites deploy to the same AWS account. The Channel dimension in telemetry
 * events distinguishes PNF traffic from RAV traffic.
 *
 * Stage is injected at deploy time via Katal manifest templating (prod).
 */

const PROD_RUM_APP_ID = 'af67d9e2-1ead-4a51-b93c-db1a60e62116';
const PROD_IDENTITY_POOL_ID = 'us-west-2:2629b9c8-5d44-4aec-b0f3-ad5fd30eae17';
const DEVO_RUM_APP_ID = '85ac0600-aacf-44cc-a0c2-005c5c2ec3db';
const DEVO_IDENTITY_POOL_ID = 'us-west-2:1f3cbd3e-832d-4649-a53b-012a7e8ff4da';

const HOSTNAME = (window.location.hostname || '').toLowerCase();
const IS_PROD_STAGE = HOSTNAME.startsWith('www.amazon');
const IS_LOCAL_DEV = ['localhost', '127.0.0.1', ''].includes(HOSTNAME);

const RUM_CONFIG = {
  identityPoolId: IS_PROD_STAGE ? PROD_IDENTITY_POOL_ID : DEVO_IDENTITY_POOL_ID,
  region: 'us-west-2',
  rumAppId: IS_PROD_STAGE ? PROD_RUM_APP_ID : DEVO_RUM_APP_ID,
};

export const initializeRUMClient = (): AwsRum | { recordEvent: (type: string, data: object) => void } | undefined => {
  if (IS_LOCAL_DEV) {
    return {
      recordEvent: (type: string, data: object) => {
        // eslint-disable-next-line no-console
        console.log('[Telemetry]', type, data);
      },
    };
  }

  try {
    const config: AwsRumConfig = {
      allowCookies: true,
      enableXRay: false,
      endpoint: `https://dataplane.rum.${RUM_CONFIG.region}.amazonaws.com`,
      identityPoolId: RUM_CONFIG.identityPoolId,
      sessionEventLimit: 0,
      sessionSampleRate: 1,
      signing: false,
      telemetries: ['performance', 'errors', 'http'],
    };

    return new AwsRum(
      RUM_CONFIG.rumAppId,
      '1.0.0',
      RUM_CONFIG.region,
      config,
    );
  } catch (error) {
    console.log('Failed to initialize RUM client:', error);
    return undefined;
  }
};
